import { createRedactor } from '@nerdwallet/redact';

const redactor = createRedactor({});

const maybeRedact = (messages: any[]): any[] => {
  // Always redact logs when not in dev
  if (process.env.NEXT_PUBLIC_DEPLOYABLE_ENV !== 'development') {
    return redactor.apply(messages);
  }

  return messages;
};

export interface Logger {
  debug(...messages: any[]): void;
  error(...messages: any[]): void;
  info(...messages: any[]): void;
  log(...messages: any[]): void;
  warn(...messages: any[]): void;
}

/**
 * Returns a logger object with `debug`, `error`, `info`, `log`, and `warn` functions.
 *
 * On client-side, `error` logs are forwarded to DataDog RUM
 * On server-side, all logs are forwarded to Coralogix
 **/
export const getLogger = (loggerName: string): Logger => ({
  debug: (...messages): void =>
    console.debug(`[${loggerName}]`, ...maybeRedact(messages)),
  error: (...messages): void =>
    console.error(`[${loggerName}]`, ...maybeRedact(messages)),
  info: (...messages): void =>
    console.info(`[${loggerName}]`, ...maybeRedact(messages)),
  log: (...messages): void =>
    console.log(`[${loggerName}]`, ...maybeRedact(messages)),
  warn: (...messages): void =>
    console.warn(`[${loggerName}]`, ...maybeRedact(messages)),
});
